// extracted by mini-css-extract-plugin
export default {"App":"Container_App__JJJYz","Container":"Container_Container__Qe21X"};